import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

/**
 * Disable scrolling on the body element.
 *
 * @param element This element (and its children) should be allowed to
 * continue scrolling and receiving touchmove events.
 */
const disable = (element: Element | HTMLElement) =>
  disableBodyScroll(element, {
    allowTouchMove: (touchTarget) => element.contains(touchTarget),
  })

/**
 * Enable scrolling on the body element.
 */
const enable = (element: Element | HTMLElement) => enableBodyScroll(element)

export const bodyScroll = {
  disable,
  enable,
}
